/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Input from '@dtvgo/input';
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableInput.scss';

export function BaseFocusableInput({
  id,
  type,
  name,
  required,
  labelContent,
  onInput,
  onMouseDown,
  onMouseEnter,
  className,
  inputValue,
  isInputActive,
  focused,
  innerRef,
  disabled,
  emptyInputText,
  warn,
  warnMsg,
}) {
  return (
    <InteractiveElement
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      <Input
        id={id}
        type={type}
        name={name}
        required={required}
        labelContent={labelContent}
        onInput={onInput}
        className={
        `dtv-html5-c-input ${focused ? 'dtv-html5-c-input--focused' : ''
        } ${warn ? 'dtv-html5-c-input--border-red' : ''} ${className}`
      }
        inputValue={inputValue}
        isInputActive={isInputActive}
        innerRef={innerRef}
        disabled={disabled}
        emptyInputText={emptyInputText}
      />
      <span className="dtv-html5-c-input--span-red">
        {warn && warnMsg}
      </span>
    </InteractiveElement>
  );
}

BaseFocusableInput.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  labelContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
  onInput: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  className: PropTypes.string,
  inputValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  isInputActive: PropTypes.bool,
  focused: PropTypes.bool.isRequired,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  disabled: PropTypes.bool,
  emptyInputText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]),
  warn: PropTypes.bool,
  warnMsg: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]),
};

BaseFocusableInput.defaultProps = {
  type: 'text',
  required: false,
  onInput: undefined,
  onMouseDown: undefined,
  onMouseEnter: undefined,
  className: '',
  inputValue: '',
  isInputActive: false,
  innerRef: undefined,
  disabled: false,
  emptyInputText: '',
  warn: false,
  warnMsg: '',
};

export default memo(withInteractiveFocusable()(memo(BaseFocusableInput)));
